import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

// 解决报错
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
// 针对 push 方法
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch((err) => err);
};
// 针对 replace 方法
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }
  return originalReplace.call(this, location).catch((err) => err);
};

const Launch = (resolve) => require(['@/views/Launch'], resolve);
const Index = (resolve) => require(['@/views/Index'], resolve);
const ActivityDescription = (resolve) =>
  require(['@/views/ActivityDescription'], resolve);
const Ranking = (resolve) => require(['@/views/Ranking'], resolve);
const VotingRules = (resolve) => require(['@/views/VotingRules'], resolve);
const VotingDetails = (resolve) => require(['@/views/VotingDetails'], resolve);
const VotingSuccess = (resolve) => require(['@/views/VotingSuccess'], resolve);

const routes = [
  {
    path: '/',
    redirect: (to) => {
      // 保留 ?id=XX 等查询参数
      return { path: '/index', query: to.query };
    },
    component: Launch,
  },
  {
    path: '/launch',
    name: 'Launch',
    component: Launch,
    meta: {
      title: '',
    },
  },
  {
    path: '/index',
    name: 'Index',
    component: Index,
    meta: {
      title: '投票首页',
      keepAlive: true,
    },
  },
  {
    path: '/activity-description',
    name: 'ActivityDescription',
    component: ActivityDescription,
    meta: {
      title: '活动介绍',
    },
  },
  {
    path: '/ranking',
    name: 'Ranking',
    component: Ranking,
    meta: {
      title: '排行',
    },
  },
  {
    path: '/voting-rules',
    name: 'VotingRules',
    component: VotingRules,
    meta: {
      title: '投票规则',
    },
  },
  {
    path: '/voting-details',
    name: 'VotingDetails',
    component: VotingDetails,
    meta: {
      title: '投票详情',
    },
  },
  {
    path: '/voting-success',
    name: 'VotingSuccess',
    component: VotingSuccess,
    meta: {
      title: '投票成功',
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(savedPosition || { x: 0, y: 0 });
      }, 5);
    });
  },
});

// 授权逻辑简化：不做前置检查，后端 401 时由 ajax 拦截器跳转微信授权
import { eventBus } from '@/common/eventBus';
import store from '@/store';
import { queryActivity } from '@/api/Api';
import {
  getAuthParams,
  getActivityId,
  shouldWaitForWechatAuth,
  isAuthPendingError,
} from '@/utils/wechatAuth';
import { canEnterIndex, isNameBoundLocal } from '@/utils/nameAuth';

router.beforeEach(async (to, from, next) => {
  const activityId = to.query.id || getActivityId();

  // 从 Launch 绑定完成进首页，跳过校验直接刷新
  if (to.name === 'Index' && (from.name === 'Launch' || store.state.nameBound)) {
    store.commit('setRefreshIndex', true);
    store.commit('setNameBound', false);
    next();
    setTimeout(() => eventBus.emit('auth:end'), 100);
    return;
  }

  if (to.name !== 'Index') {
    next();
    setTimeout(() => eventBus.emit('auth:end'), 100);
    return;
  }

  // OAuth 回调落在 Index：已绑定留首页，未绑定去 Launch
  if (to.query.code && shouldWaitForWechatAuth()) {
    if (isNameBoundLocal(activityId)) {
      store.commit('setRefreshIndex', true);
      next();
      setTimeout(() => eventBus.emit('auth:end'), 100);
      return;
    }
    next({
      path: '/launch',
      query: { ...to.query, id: activityId },
      replace: true,
    });
    setTimeout(() => eventBus.emit('auth:end'), 100);
    return;
  }

  // 直达首页：未绑姓名须先去 Launch
  try {
    const res = await queryActivity({ ...getAuthParams() });
    if (Number(res.status) === 401 || !canEnterIndex(res, activityId)) {
      next({
        path: '/launch',
        query: { ...to.query, id: activityId },
        replace: true,
      });
      return;
    }
    next();
  } catch (e) {
    if (isAuthPendingError(e)) {
      next({
        path: '/launch',
        query: { ...to.query, id: activityId },
        replace: true,
      });
      return;
    }
    next({
      path: '/launch',
      query: { ...to.query, id: activityId },
      replace: true,
    });
  }
  setTimeout(() => eventBus.emit('auth:end'), 100);
});

export default router;
